import React from 'react';
import { useParams } from 'react-router-dom';
import Loadable from 'react-loadable';
import { getApplicationByNumber, getOperations } from 'api';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectAct } from './api';
import { DefectActProvider } from './providers';

export const path = '/application/:applicationNumber/defect-act';

export const getPath = (applicationNumber: string): string => `/application/${applicationNumber}/defect-act`;

const PageDefectAct: React.FC = (props) => {
  const { applicationNumber } = useParams<{ applicationNumber: string }>();

  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      application: () => getApplicationByNumber(applicationNumber),
      defectAct: () => getDefectAct(applicationNumber),
      operations: () => getOperations({ applicationNumber }),
    },
    loading: LoadableLoading,
    render({ application, defectAct, operations, page }, loadedProps: {}) {
      const Page = page.default;

      return (
        <DefectActProvider application={application} defectAct={defectAct} operations={operations}>
          <Page {...loadedProps} />
        </DefectActProvider>
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PageDefectAct;
